import BaseService from './base.service';

/** Platform versions from sage-nest-api (`platform_app_versions`). */
export default class PlatformService {
    static ENDPOINT = '/platform';

    /**
     * Public, no sign-in needed. Whether the tab running `appVersion` has to move to
     * `deployedVersion` (from /version.json): `{ force_update: true | false | null, message }` —
     * true = required, false = optional, null = none.
     */
    static async checkWebUpdate(appVersion, deployedVersion) {
        return BaseService.post(`${this.ENDPOINT}/check-web-update`, {
            app_version: appVersion,
            deployed_version: deployedVersion
        });
    }

    /** Super admin: the whole `platform_app_versions/current` document (`ios`, `android`, `web`). */
    static async getAppVersionConfig() {
        return BaseService.get(`${this.ENDPOINT}/app-versions/config`);
    }

    /**
     * Super admin: replaces one platform's entry and returns the updated document.
     * `platform` is `ios`, `android` or `web`; web has no minimum version.
     */
    static async updateAppVersion(platform, entry) {
        const path = platform === 'web' ? 'web' : `mobile/${platform}`;
        return BaseService.put(`${this.ENDPOINT}/app-versions/${path}`, entry);
    }
}
